import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Store Roles
  storeRolesListApiData,
  storeRolesListApiSuccess,
  storeRolesListApiFailed,

  // Add store roles
  addStoreRolesApiData,
  addStoreRolesApiSuccess,
  addStoreRolesApiFailed,

  // Update Store Roles
  updateStoreRolesApiData,
  updateStoreRolesApiSuccess,
  updateStoreRolesApiFailed,

  // Store Type
  getStoreTypeListApiData,
  getStoreTypeListApiDataSuccess,
  getStoreTypeListApiDataFailed,

  // add Store Type
  addStoreTypeListApiData,
  addStoreTypeListApiSuccess,
  addStoreTypeListApiFailed,
  // Update Store Type
  updateStoreTypeListApiData,
  updateStoreTypeListApiSuccess,
  updateStoreTypeListApiFailed,
  //delete Store Type
  deleteStoreTypeListApiData,
  deleteStoreTypeListApiSuccess,
  deleteStoreTypeListApiFailed,
  // details Store type
  getStoreTypeDetailsListApiData,
  getStoreTypeDetailsListApiSuccess,
  getStoreTypeDetailsListApiFailed,

  // grocery Categories List
  storeCategoryListApiData,
  storeCategoryListApiSuccess,
  storeCategoryListApiFailed,

  // grocery Categories List Details
  storeCategoryDetailsApiData,
  storeCategoryDetailsApiSuccess,
  storeCategoryDetailsApiFailed,

  // Add Store category in List
  addStoreCategoryApiData,
  addStoreCategoryApiSuccess,
  addStoreCategoryApiFailed,

  // Update Store Category
  updateStoreCategoryListApiData,
  updateStoreCategoryApiSuccess,
  updateStoreCategoryApiFailed,

  // delete Category
  deleteStoreProductCategoryDataApiData,
  deleteStoreProductCategoryDataApiSuccess,
  deleteStoreProductCategoryDataApiFailed,

  // Grocery Sub Category List
  storeSubCategoryListApiData,
  storeSubCategoryListApiSuccess,
  storeSubCategoryListApiFailed,

  // Grocery Sub Category Details
  storeSubCategoryDetailsApiData,
  storeSubCategoryDetailsApiSuccess,
  storeSubCategoryDetailsApiFailed,

  // Add Sub Category
  addSubStoreCategoryApiData,
  addSubStoreCategoryApiSuccess,
  addSubStoreCategoryApiFailed,

  // Update Store Sub Category
  updateStoreSubCategoryListApiData,
  updateStoreSubCategoryListApiSuccess,
  updateStoreSubCategoryListApiFailed,

  // delete Sub Category Store
  deleteStoreSubProductCategoryApiData,
  deleteStoreSubProductCategoryApiSuccess,
  deleteStoreSubProductCategoryApiFailed,

  // Child SubCategory List
  storeProductSubChildCategoriesListApiData,
  storeProductSubChildCategoriesListApiSuccess,
  storeProductSubChildCategoriesListApiFailed,

  //Child SubCategory List Details
  storeProductSubChildCategoriesItemDetailsApiData,
  storeProductSubChildCategoriesItemDetailsApiSuccess,
  storeProductSubChildCategoriesItemDetailsApiFailed,

  // Add Store Child Sub Category
  addStoreProductChildSubCategoryApiData,
  addStoreProductChildSubCategoryApiSuccess,
  addStoreProductChildSubCategoryApiFailed,
  // Update Store Child Sub Category
  updateStoreChildSubCategoryListApiData,
  updateStoreChildSubCategoryListApiSuccess,
  updateStoreChildSubCategoryListApiFailed,
  // Delete Child Category
  deleteStoreProductChildSubCategoryApiData,
  deleteStoreProductChildSubCategoryApiSuccess,
  deleteStoreProductChildSubCategoryApiFailed,

  // Brands

  // Brand List
  brandListApiData,
  brandListApiSuccess,
  brandListApiFailed,
  // Brands details
  brandNameDetailsApiData,
  brandNameDetailsApiSuccess,
  brandNameDetailsApiFailed,

  // AddBrands
  addBrandApiData,
  addBrandApiSuccess,
  addBrandApiFailed,

  // Update Brands
  updateBrandApiData,
  updateBrandApiSuccess,
  updateBrandApiFailed,

  // Delete Brands
  deleteBrandApiData,
  deleteBrandApiSuccess,
  deleteBrandApiFailed,

  // List Store Group
  getStoreGroupListApiData,
  getStoreGroupListApiSuccess,
  getStoreGroupListApiFailed,

  // add store group
  addStoreGroupListApiData,
  addStoreGroupListApiSuccess,
  addStoreGroupListApiFailed,

  // update store Group
  updateStoreGroupListApiData,
  updateStoreGroupListApiSuccess,
  updateStoreGroupListApiFailed,

  // delete Store group
  activeInactiveStoreGroupListApiData,
  activeInactiveStoreGroupListApiSuccess,
  activeInactiveStoreGroupListApiFailed,

  // delete Store group
  deleteStoreGroupListApiData,
  deleteStoreGroupListApiSuccess,
  deleteStoreGroupListApiFailed,

  // store group details
  getStoreGroupDetailsListApiData,
  getStoreGroupDetailsListApiSuccess,
  getStoreGroupDetailsListApiFailed,
  // store Tags
  getStoreTagListApiData,
  getStoreTagListApiSuccess,
  getStoreTagListApiFailed,

  // Add Store Tags
  addStoreTagApiData,
  addStoreTagApiSuccess,
  addStoreTagApiFailed,

  // update Store Tag
  updateStoreTagApiData,
  updateStoreTagApiSuccess,
  updateStoreTagApiFailed,

  // delete Store Tag
  deleteStoreTagApiData,
  deleteStoreTagApiSuccess,
  deleteStoreTagApiFailed,

  // Active InACtive Store Tag
  activeInactiveStoreTagListApiData,
  activeInactiveStoreTagListApiSuccess,
  activeInactiveStoreTagListApiFailed,

  // Store Roles Active InActive
  activeInactiveStoreRolesListApiData,
  activeInactiveStoreRolesListApiSuccess,
  activeInactiveStoreRolesListApiFailed,
  // Store Type Active Inactive
  activeInactiveStoreTypeListApiData,
  activeInactiveStoreTypeListApiSuccess,
  activeInactiveStoreTypeListApiFailed,

  // Enquiry List
  getEnquiryListApiData,
  getEnquiryListApiSuccess,
  getEnquiryListApiFailed,
  // Enquiry List Details
  getEnquiryDetailsListApiData,
  getEnquiryDetailsListApiSuccess,
  getEnquiryDetailsListApiFailed,
  getStoreVideoCategoryListApiData,
  getStoreVideoCategoryListApiSuccess,
  getStoreVideoCategoryListApiFailed,
  addStoreVideoCategoryApiData,
  addStoreVideoCategoryApiSuccess,
  addStoreVideoCategoryApiFailed,
  updateStoreVideoCategoryApiData,
  updateStoreVideoCategoryApiSuccess,
  updateStoreVideoCategoryApiFailed,
  activeInactiveStoreVideoCategoryApiData,
  activeInactiveStoreVideoCategoryApiSuccess,
  activeInactiveStoreVideoCategoryApiFailed,
  getStoreVideoListApiData,
  getStoreVideoListApiSuccess,
  getStoreVideoListApiFailed,
  addStoreVideoApiData,
  addStoreVideoApiSuccess,
  addStoreVideoApiFailed,
  updateStoreVideoApiData,
  updateStoreVideoApiSuccess,
  updateStoreVideoApiFailed,
  activeInactiveStoreVideoApiData,
  activeInactiveStoreVideoApiSuccess,
  activeInactiveStoreVideoApiFailed,
  getVideoDetailsData,
  getVideoDetailsApiSuccess,
  getVideoDetailsApiFailed,
  getStoreOfferCategoryListApiData,
  getStoreOfferCategoryListApiSuccess,
  getStoreOfferCategoryListApiFailed,
  getStoreOfferCategoryDetailsApiData,
  getStoreOfferCategoryDetailsApiSuccess,
  getStoreOfferCategoryDetailsApiFailed,
  addStoreOfferCategoryApiData,
  addStoreOfferCategoryApiSuccess,
  addStoreOfferCategoryApiFailed,
  updateStoreOfferCategoryApiData,
  updateStoreOfferCategoryApiSuccess,
  updateStoreOfferCategoryApiFailed,
  activeInactiveStoreOfferCategoryApiData,
  activeInactiveStoreOfferCategoryApiSuccess,
  activeInactiveStoreOfferCategoryApiFailed,
  getStoreOfferListApiData,
  getStoreOfferListApiSuccess,
  getStoreOfferListApiFailed,
  getStoreOfferDetailsApiData,
  getStoreOfferDetailsApiSuccess,
  getStoreOfferDetailsApiFailed,
  updateOfferApiData,
  updateOfferApiSuccess,
  updateOfferApiFailed,
  getOfferSubCategoryListApiData,
  getOfferSubCategoryListApiSuccess,
  getOfferSubCategoryListApiFailed,
  addOfferSubCategoryApiData,
  addOfferSubCategoryApiSuccess,
  addOfferSubCategoryApiFailed,
  updateOfferSubCategoryApiData,
  updateOfferSubCategoryApiSuccess,
  updateOfferSubCategoryApiFailed,
  activeInactiveOfferSubCategoryApiData,
  activeInactiveOfferSubCategoryApiSuccess,
  activeInactiveOfferSubCategoryApiFailed,
  getOfferSubCategoryDetailsApiData,
  getOfferSubCategoryDetailsApiSuccess,
  getOfferSubCategoryDetailsApiFailed,

  // ================= Internship Super Category =================
  getInternshipSuperCategoryListApiData,
  getInternshipSuperCategoryListApiSuccess,
  getInternshipSuperCategoryListApiFailed,
  getInternshipSuperCategoryDetailsApiData,
  getInternshipSuperCategoryDetailsApiSuccess,
  getInternshipSuperCategoryDetailsApiFailed,
  addInternshipSuperCategoryApiData,
  addInternshipSuperCategoryApiSuccess,
  addInternshipSuperCategoryApiFailed,
  updateInternshipSuperCategoryApiData,
  updateInternshipSuperCategoryApiSuccess,
  updateInternshipSuperCategoryApiFailed,
  deleteInternshipSuperCategoryApiData,
  deleteInternshipSuperCategoryApiSuccess,
  deleteInternshipSuperCategoryApiFailed,
  activeInactiveInternshipSuperCategoryApiData,
  activeInactiveInternshipSuperCategoryApiSuccess,
  activeInactiveInternshipSuperCategoryApiFailed,

  // ================= Internship Category =================
  getInternshipCategoryListApiData,
  getInternshipCategoryListApiSuccess,
  getInternshipCategoryListApiFailed,
  addInternshipCategoryApiData,
  addInternshipCategoryApiSuccess,
  addInternshipCategoryApiFailed,
  updateInternshipCategoryApiData,
  updateInternshipCategoryApiSuccess,
  updateInternshipCategoryApiFailed,
  activeInactiveInternshipCategoryApiData,
  activeInactiveInternshipCategoryApiSuccess,
  activeInactiveInternshipCategoryApiFailed,

  // ================= Internship SubCategory =================
  getInternshipSubCategoryListApiData,
  getInternshipSubCategoryListApiSuccess,
  getInternshipSubCategoryListApiFailed,
  addInternshipSubCategoryApiData,
  addInternshipSubCategoryApiSuccess,
  addInternshipSubCategoryApiFailed,
  updateInternshipSubCategoryApiData,
  updateInternshipSubCategoryApiSuccess,
  updateInternshipSubCategoryApiFailed,
  activeInactiveInternshipSubCategoryApiData,
  activeInactiveInternshipSubCategoryApiSuccess,
  activeInactiveInternshipSubCategoryApiFailed,
  deleteInternshipSubCategoryApiData,
  deleteInternshipSubCategoryApiSuccess,
  deleteInternshipSubCategoryApiFailed,

  // ================= Internship Programs =================
  getInternshipProgramListApiData,
  getInternshipProgramListApiSuccess,
  getInternshipProgramListApiFailed,
  getInternshipProgramDetailsApiData,
  getInternshipProgramDetailsApiSuccess,
  getInternshipProgramDetailsApiFailed,
  deleteInternshipProgramApiData,
  deleteInternshipProgramApiSuccess,
  deleteInternshipProgramApiFailed,

  // ================= Applied Internship =================
  getAppliedInternshipListApiData,
  getAppliedInternshipListApiSuccess,
  getAppliedInternshipListApiFailed,

  // Skill Program
  getSkillProgramTypesListApiData,
  getSkillProgramTypesListApiSuccess,
  getSkillProgramTypesListApiFailed,
  addSkillProgramTypesApiData,
  addSkillProgramTypesApiSuccess,
  addSkillProgramTypesApiFailed,
  updateSkillProgramTypesApiData,
  updateSkillProgramTypesApiSuccess,
  updateSkillProgramTypesApiFailed,
  activeInactiveSkillProgramTypesApiData,
  activeInactiveSkillProgramTypesApiSuccess,
  activeInactiveSkillProgramTypesApiFailed,
  getSkillSuperCategoryListApiData,
  getSkillSuperCategoryListApiSuccess,
  getSkillSuperCategoryListApiFailed,
  getSkillSuperCategoryDetailsApiData,
  getSkillSuperCategoryDetailsApiSuccess,
  getSkillSuperCategoryDetailsApiFailed,
  addSkillSuperCategoryApiData,
  addSkillSuperCategoryApiSuccess,
  addSkillSuperCategoryApiFailed,
  updateSkillSuperCategoryApiData,
  updateSkillSuperCategoryApiSuccess,
  updateSkillSuperCategoryApiFailed,
  deleteSkillSuperCategoryApiData,
  deleteSkillSuperCategoryApiSuccess,
  deleteSkillSuperCategoryApiFailed,
  activeInactiveSkillSuperCategoryApiData,
  activeInactiveSkillSuperCategoryApiSuccess,
  activeInactiveSkillSuperCategoryApiFailed,
  getSkillCategoryListApiData,
  getSkillCategoryListApiSuccess,
  getSkillCategoryListApiFailed,
  addSkillCategoryApiData,
  addSkillCategoryApiSuccess,
  addSkillCategoryApiFailed,
  updateSkillCategoryApiData,
  updateSkillCategoryApiSuccess,
  updateSkillCategoryApiFailed,
  activeInactiveSkillCategoryApiData,
  activeInactiveSkillCategoryApiSuccess,
  activeInactiveSkillCategoryApiFailed,
  getSkillSubCategoryListApiData,
  getSkillSubCategoryListApiSuccess,
  getSkillSubCategoryListApiFailed,
  addSkillSubCategoryApiData,
  addSkillSubCategoryApiSuccess,
  addSkillSubCategoryApiFailed,
  updateSkillSubCategoryApiData,
  updateSkillSubCategoryApiSuccess,
  updateSkillSubCategoryApiFailed,
  activeInactiveSkillSubCategoryApiData,
  activeInactiveSkillSubCategoryApiSuccess,
  activeInactiveSkillSubCategoryApiFailed,
  getSkillProgramListApiData,
  getSkillProgramListApiSuccess,
  getSkillProgramListApiFailed,
  getSkillProgramDetailsApiData,
  getSkillProgramDetailsApiSuccess,
  getSkillProgramDetailsApiFailed,
  deleteSkillProgramApiData,
  deleteSkillProgramApiSuccess,
  deleteSkillProgramApiFailed,
  getAppliedSkillListApiData,
  getAppliedSkillListApiSuccess,
  getAppliedSkillListApiFailed,
  getAppliedSkillDetailsApiData,
  getAppliedSkillDetailsApiSuccess,
  getAppliedSkillDetailsApiFailed,
  deleteInternshipCategoryApiData,
  deleteInternshipCategoryApiSuccess,
  deleteInternshipCategoryApiFailed,
  deleteSkillProgramTypesApiData,
  deleteSkillProgramTypesApiSuccess,
  deleteSkillProgramTypesApiFailed,
  deleteSkillCategoryApiData,
  deleteSkillCategoryApiSuccess,
  deleteSkillCategoryApiFailed,
  deleteSkillSubCategoryApiData,
  deleteSkillSubCategoryApiSuccess,
  deleteSkillSubCategoryApiFailed,
} from './slice'

import { API } from '../../services'

function* storeRolesListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.storeRolesList, payload)
    if (response.data && response.status === 200) {
      yield put(storeRolesListApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeRolesListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeRolesListApiFailed({ message: error?.message }))
  }
}
function* addStoreRolesApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addStoreRoles, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreRolesApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreRolesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreRolesApiFailed({ message: error?.message }))
  }
}
function* updateStoreRolesApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreRoles, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreRolesApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreRolesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreRolesApiFailed({ message: error?.message }))
  }
}

// Store Type
function* getStoreListTypeApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getStoreTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreTypeListApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreTypeListApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreTypeListApiDataFailed({ message: error?.message }))
  }
}
function* addStoreTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addStoreTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreTypeListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreTypeListApiFailed({ message: error?.message }))
  }
}
function* updateStoreTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreTypeListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreTypeListApiFailed({ message: error?.message }))
  }
}
function* deleteStoreTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteStoreTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreTypeListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreTypeListApiFailed({ message: error?.message }))
  }
}
function* getStoreTypeDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getStoreTypeDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreTypeDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreTypeDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreTypeDetailsListApiFailed({ message: error?.message }))
  }
}
function* storeCategoryListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.storeCategoriesList, payload)
    if (response.data && response.status === 200) {
      yield put(storeCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeCategoryListApiFailed({ message: error?.message }))
  }
}
function* storeCategoryDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.storeCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(storeCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeCategoryDetailsApiFailed({ message: error?.message }))
  }
}
function* addStoreCategoryApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addStoreCategory, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreCategoryApiFailed({ message: error?.message }))
  }
}
function* updateStoreCategoryListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreCategoryApiFailed({ message: error?.message }))
  }
}
function* deleteStoreProductCategoryDataApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteStoreProductCategoryData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreProductCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreProductCategoryDataApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreProductCategoryDataApiFailed({ message: error?.message }))
  }
}
function* storeSubCategoryListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.storeSubCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(storeSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeSubCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeSubCategoryListApiFailed({ message: error?.message }))
  }
}
function* storeSubCategoryDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.storeSubCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(storeSubCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeSubCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeSubCategoryDetailsApiFailed({ message: error?.message }))
  }
}
function* addSubStoreCategoryApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addSubStoreCategory, payload)
    if (response.data && response.status === 200) {
      yield put(addSubStoreCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addSubStoreCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSubStoreCategoryApiFailed({ message: error?.message }))
  }
}
function* updateStoreSubCategoryListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreSubCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreSubCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreSubCategoryListApiFailed({ message: error?.message }))
  }
}
function* deleteStoreSubProductCategoryApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteStoreSubProductCategory, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreSubProductCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreSubProductCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreSubProductCategoryApiFailed({ message: error?.message }))
  }
}

// Child Category
function* storeProductSubChildCategoriesListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.storeProductSubChildCategoriesList, payload)
    if (response.data && response.status === 200) {
      yield put(storeProductSubChildCategoriesListApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeProductSubChildCategoriesListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeProductSubChildCategoriesListApiFailed({ message: error?.message }))
  }
}
function* storeProductSubChildCategoriesItemDetailsApi({ type, payload }) {
  try {
    const response = yield call(
      API.storeManagement.storeProductSubChildCategoriesItemDetails,
      payload,
    )
    if (response.data && response.status === 200) {
      yield put(storeProductSubChildCategoriesItemDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(storeProductSubChildCategoriesItemDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(storeProductSubChildCategoriesItemDetailsApiFailed({ message: error?.message }))
  }
}
function* addStoreProductChildSubCategoryApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addStoreProductChildSubCategory, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreProductChildSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreProductChildSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreProductChildSubCategoryApiFailed({ message: error?.message }))
  }
}
function* updateStoreChildSubCategoryListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreChildSubCategoryList, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreChildSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreChildSubCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreChildSubCategoryListApiFailed({ message: error?.message }))
  }
}
function* deleteStoreProductChildSubCategoryApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteStoreProductChildSubCategory, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreProductChildSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreProductChildSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreProductChildSubCategoryApiFailed({ message: error?.message }))
  }
}
function* brandListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.brandList, payload)
    if (response.data && response.status === 200) {
      yield put(brandListApiSuccess({ payload: response?.data }))
    } else {
      yield put(brandListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(brandListApiFailed({ message: error?.message }))
  }
}
function* brandNameDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.brandNameDetails, payload)
    if (response.data && response.status === 200) {
      yield put(brandNameDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(brandNameDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(brandNameDetailsApiFailed({ message: error?.message }))
  }
}
function* addBrandApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addBrand, payload)
    if (response.data && response.status === 200) {
      yield put(addBrandApiSuccess({ payload: response?.data }))
    } else {
      yield put(addBrandApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addBrandApiFailed({ message: error?.message }))
  }
}
function* updateBrandApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateBrand, payload)
    if (response.data && response.status === 200) {
      yield put(updateBrandApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateBrandApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateBrandApiFailed({ message: error?.message }))
  }
}
function* deleteBrandApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteBrand, payload)
    if (response.data && response.status === 200) {
      yield put(deleteBrandApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteBrandApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteBrandApiFailed({ message: error?.message }))
  }
}
function* getStoreGroupListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getStoreGroupList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreGroupListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreGroupListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreGroupListApiFailed({ message: error?.message }))
  }
}
function* addStoreGroupListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addStoreGroupList, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreGroupListApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreGroupListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreGroupListApiFailed({ message: error?.message }))
  }
}
function* updateStoreGroupListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreGroupList, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreGroupListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreGroupListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreGroupListApiFailed({ message: error?.message }))
  }
}
function* activeInactiveStoreGroupListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.activeInactiveStoreGroupList, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveStoreGroupListApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveStoreGroupListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreGroupListApiFailed({ message: error?.message }))
  }
}
function* deleteStoreGroupListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteStoreGroup, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreGroupListApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreGroupListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreGroupListApiFailed({ message: error?.message }))
  }
}
function* getStoreGroupDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getStoreGroupDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreGroupDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreGroupDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreGroupDetailsListApiFailed({ message: error?.message }))
  }
}
function* getStoreTagListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getStoreTagList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreTagListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreTagListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreTagListApiFailed({ message: error?.message }))
  }
}
function* addStoreTagApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.addStoreTag, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreTagApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreTagApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreTagApiFailed({ message: error?.message }))
  }
}
function* updateStoreTagApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.updateStoreTag, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreTagApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreTagApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreTagApiFailed({ message: error?.message }))
  }
}
function* deleteStoreTagApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.deleteStoreTag, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreTagApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreTagApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreTagApiFailed({ message: error?.message }))
  }
}
function* activeInactiveStoreTagListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.activeInactiveStoreTagList, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveStoreTagListApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveStoreTagListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreTagListApiFailed({ message: error?.message }))
  }
}

function* activeInactiveStoreRolesListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.activeInactiveStoreRolesList, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveStoreRolesListApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveStoreRolesListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreRolesListApiFailed({ message: error?.message }))
  }
}
function* activeInactiveStoreTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.activeInactiveStoreTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(activeInactiveStoreTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveStoreTypeListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreTypeListApiFailed({ message: error?.message }))
  }
}
function* getEnquiryListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getEnguiryList, payload)
    if (response.data && response.status === 200) {
      yield put(getEnquiryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getEnquiryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEnquiryListApiFailed({ message: error?.message }))
  }
}
function* getEnquiryDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.storeManagement.getEnquiryDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getEnquiryDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getEnquiryDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEnquiryDetailsListApiFailed({ message: error?.message }))
  }
}

// List
function* getStoreVideoCategoryListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.getVideoCategoryList, payload)
    if (response.status === 200) {
      yield put(getStoreVideoCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getStoreVideoCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreVideoCategoryListApiFailed({ message: error?.message }))
  }
}

// Add
function* addStoreVideoCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.addVideoCategory, payload)
    if (response.status === 200) {
      yield put(addStoreVideoCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addStoreVideoCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreVideoCategoryApiFailed({ message: error?.message }))
  }
}

// Update
function* updateStoreVideoCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.updateVideoCategory, payload)
    if (response.status === 200) {
      yield put(updateStoreVideoCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateStoreVideoCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreVideoCategoryApiFailed({ message: error?.message }))
  }
}

// Active / Inactive
function* activeInactiveStoreVideoCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.activeInactiveVideoCategory, payload)
    if (response.status === 200) {
      yield put(activeInactiveStoreVideoCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveStoreVideoCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreVideoCategoryApiFailed({ message: error?.message }))
  }
}

// List
function* getStoreVideoListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.getVideoList, payload)
    if (response.status === 200) {
      yield put(getStoreVideoListApiSuccess({ payload: response.data }))
    } else {
      yield put(getStoreVideoListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreVideoListApiFailed({ message: error?.message }))
  }
}
// List
function* getVideoDetails({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.getVideoDetails, payload)
    if (response.status === 200) {
      yield put(getVideoDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getVideoDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getVideoDetailsApiFailed({ message: error?.message }))
  }
}

// Add
function* addStoreVideoApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.addVideo, payload)
    if (response.status === 200) {
      yield put(addStoreVideoApiSuccess({ payload: response.data }))
    } else {
      yield put(addStoreVideoApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreVideoApiFailed({ message: error?.message }))
  }
}

// Update
function* updateStoreVideoApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.updateVideo, payload)
    if (response.status === 200) {
      yield put(updateStoreVideoApiSuccess({ payload: response.data }))
    } else {
      yield put(updateStoreVideoApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreVideoApiFailed({ message: error?.message }))
  }
}

// Active / Inactive
function* activeInactiveStoreVideoApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.storeVideo.activeInactiveVideo, payload)
    if (response.status === 200) {
      yield put(activeInactiveStoreVideoApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveStoreVideoApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreVideoApiFailed({ message: error?.message }))
  }
}

// ================= Offer Category =================

// LIST
function* getStoreOfferCategoryListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.getOfferCategoryList, payload)
    if (response.status === 200) {
      yield put(getStoreOfferCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getStoreOfferCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreOfferCategoryListApiFailed({ message: error?.message }))
  }
}

// DETAILS
function* getStoreOfferCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.getOfferCategoryDetails, payload)
    if (response.status === 200) {
      yield put(getStoreOfferCategoryDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getStoreOfferCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreOfferCategoryDetailsApiFailed({ message: error?.message }))
  }
}

// ADD
function* addStoreOfferCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.addOfferCategory, payload)
    if (response.status === 200) {
      yield put(addStoreOfferCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addStoreOfferCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreOfferCategoryApiFailed({ message: error?.message }))
  }
}

// UPDATE
function* updateStoreOfferCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.updateOfferCategory, payload)
    if (response.status === 200) {
      yield put(updateStoreOfferCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateStoreOfferCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreOfferCategoryApiFailed({ message: error?.message }))
  }
}

// ACTIVE / INACTIVE
function* activeInactiveStoreOfferCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.activeInactiveOfferCategory, payload)
    if (response.status === 200) {
      yield put(activeInactiveStoreOfferCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveStoreOfferCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveStoreOfferCategoryApiFailed({ message: error?.message }))
  }
}

function* getStoreOfferListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.getStoreOfferList, payload)

    if (response.status === 200) {
      yield put(getStoreOfferListApiSuccess({ payload: response.data }))
    } else {
      yield put(getStoreOfferListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreOfferListApiFailed({ message: error?.message }))
  }
}

function* getStoreOfferDetailsApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.getStoreOfferDetails, payload)

    if (response.status === 200) {
      yield put(getStoreOfferDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getStoreOfferDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreOfferDetailsApiFailed({ message: error?.message }))
  }
}

// -------- Update Offer --------
function* updateOfferApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.updateStoreOffer, payload)
    if (response.data && response.status === 200) {
      yield put(updateOfferApiSuccess(response.data))
    } else {
      yield put(updateOfferApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateOfferApiFailed({ message: error.message }))
  }
}

function* getOfferSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.getOfferSubCategoryList, payload)

    if (response.data && response.status === 200) {
      yield put(getOfferSubCategoryListApiSuccess(response.data))
    } else {
      yield put(getOfferSubCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getOfferSubCategoryListApiFailed({ message: error.message }))
  }
}

function* addOfferSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.addOfferSubCategory, payload)

    if (response.status === 200) {
      yield put(addOfferSubCategoryApiSuccess(response.data))
    } else {
      yield put(addOfferSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addOfferSubCategoryApiFailed({ message: error.message }))
  }
}

function* updateOfferSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.updateOfferSubCategory, payload)

    if (response.status === 200) {
      yield put(updateOfferSubCategoryApiSuccess(response.data))
    } else {
      yield put(updateOfferSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateOfferSubCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveOfferSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.activeInactiveOfferSubCategory, payload)

    if (response.status === 200) {
      yield put(activeInactiveOfferSubCategoryApiSuccess(response.data))
    } else {
      yield put(activeInactiveOfferSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveOfferSubCategoryApiFailed({ message: error.message }))
  }
}

function* getOfferSubCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.offer.getOfferSubCategoryDetails, payload)

    if (response.data && response.status === 200) {
      yield put(getOfferSubCategoryDetailsApiSuccess(response.data))
    } else {
      yield put(
        getOfferSubCategoryDetailsApiFailed({
          message: response?.message || 'Failed to fetch details',
        }),
      )
    }
  } catch (error) {
    yield put(
      getOfferSubCategoryDetailsApiFailed({
        message: error.message,
      }),
    )
  }
}

function* getInternshipSuperCategoryListApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getInternshipSuperCategoryList,
      payload,
    )
    if (response.status === 200) {
      yield put(getInternshipSuperCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getInternshipSuperCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getInternshipSuperCategoryListApiFailed({ message: error.message }))
  }
}

function* getInternshipSuperCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getInternshipSuperCategoryDetails,
      payload,
    )
    if (response.status === 200) {
      yield put(getInternshipSuperCategoryDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getInternshipSuperCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getInternshipSuperCategoryDetailsApiFailed({ message: error.message }))
  }
}

function* addInternshipSuperCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.addInternshipSuperCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(addInternshipSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addInternshipSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addInternshipSuperCategoryApiFailed({ message: error.message }))
  }
}

function* updateInternshipSuperCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.updateInternshipSuperCategory,
      payload,
    )
    if (response.status === 200) {
      yield put(updateInternshipSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateInternshipSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateInternshipSuperCategoryApiFailed({ message: error.message }))
  }
}

function* deleteInternshipSuperCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.deleteInternshipSuperCategory,
      payload,
    )
    if (response.status === 200 || response.status === 204) {
      yield put(deleteInternshipSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteInternshipSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteInternshipSuperCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveInternshipSuperCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.activeInactiveInternshipSuperCategory,
      payload,
    )
    if (response.status === 200) {
      yield put(activeInactiveInternshipSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveInternshipSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveInternshipSuperCategoryApiFailed({ message: error.message }))
  }
}

// ================= Internship Category Sagas =================
function* getInternshipCategoryListApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getInternshipCategoryList,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(getInternshipCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getInternshipCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getInternshipCategoryListApiFailed({ message: error.message }))
  }
}

function* addInternshipCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.addInternshipCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(addInternshipCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addInternshipCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addInternshipCategoryApiFailed({ message: error.message }))
  }
}

function* updateInternshipCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.updateInternshipCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(updateInternshipCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateInternshipCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateInternshipCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveInternshipCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.activeInactiveInternshipCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(activeInactiveInternshipCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveInternshipCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveInternshipCategoryApiFailed({ message: error.message }))
  }
}

function* deleteInternshipCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.deleteInternshipCategory,
      payload,
    )
    if (response.status === 200 || response.status === 204) {
      yield put(deleteInternshipCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteInternshipCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteInternshipCategoryApiFailed({ message: error.message }))
  }
}

// ================= Internship SubCategory Sagas =================
function* getInternshipSubCategoryListApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getInternshipSubCategoryList,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(getInternshipSubCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getInternshipSubCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getInternshipSubCategoryListApiFailed({ message: error.message }))
  }
}

function* addInternshipSubCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.addInternshipSubCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(addInternshipSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addInternshipSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addInternshipSubCategoryApiFailed({ message: error.message }))
  }
}

function* updateInternshipSubCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.updateInternshipSubCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(updateInternshipSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateInternshipSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateInternshipSubCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveInternshipSubCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.activeInactiveInternshipSubCategory,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(activeInactiveInternshipSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveInternshipSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveInternshipSubCategoryApiFailed({ message: error.message }))
  }
}

function* deleteInternshipSubCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.deleteInternshipSubCategory,
      payload,
    )
    if (response.status === 200 || response.status === 204) {
      yield put(deleteInternshipSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteInternshipSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteInternshipSubCategoryApiFailed({ message: error.message }))
  }
}

// ================= Internship Program Sagas =================
function* getInternshipProgramListApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getInternshipProgramList,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(getInternshipProgramListApiSuccess({ payload: response.data }))
    } else {
      yield put(getInternshipProgramListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getInternshipProgramListApiFailed({ message: error.message }))
  }
}

function* getInternshipProgramDetailsApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getInternshipProgramDetails,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(getInternshipProgramDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getInternshipProgramDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getInternshipProgramDetailsApiFailed({ message: error.message }))
  }
}

function* deleteInternshipProgramApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.deleteInternshipProgram,
      payload,
    )
    if (response.status === 200 || response.status === 204) {
      yield put(deleteInternshipProgramApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteInternshipProgramApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteInternshipProgramApiFailed({ message: error.message }))
  }
}

// ================= Applied Internship Sagas =================
function* getAppliedInternshipListApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.internshipManagement.getAppliedInternshipList,
      payload,
    )
    if (response.status === 200 || response.status === 201) {
      yield put(getAppliedInternshipListApiSuccess({ payload: response.data }))
    } else {
      yield put(getAppliedInternshipListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAppliedInternshipListApiFailed({ message: error.message }))
  }
}

// ================= Skill Program Sagas =================

// -------- Program Types --------
function* getSkillProgramTypesListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getProgramTypes, payload)
    if (response.status === 200) {
      yield put(getSkillProgramTypesListApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillProgramTypesListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillProgramTypesListApiFailed({ message: error.message }))
  }
}

function* addSkillProgramTypesApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.addProgramType, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(addSkillProgramTypesApiSuccess({ payload: response.data }))
    } else {
      yield put(addSkillProgramTypesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSkillProgramTypesApiFailed({ message: error.message }))
  }
}

function* updateSkillProgramTypesApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.updateProgramType, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(updateSkillProgramTypesApiSuccess({ payload: response.data }))
    } else {
      yield put(updateSkillProgramTypesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSkillProgramTypesApiFailed({ message: error.message }))
  }
}

function* activeInactiveSkillProgramTypesApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.toggleProgramTypeStatus, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(activeInactiveSkillProgramTypesApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveSkillProgramTypesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveSkillProgramTypesApiFailed({ message: error.message }))
  }
}

function* deleteSkillProgramTypesApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.deleteProgramType, payload)
    if (response.status === 200 || response.status === 204) {
      yield put(deleteSkillProgramTypesApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteSkillProgramTypesApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSkillProgramTypesApiFailed({ message: error.message }))
  }
}

function* getSkillSuperCategoryListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getSkillSuperCategoryList, payload)
    if (response.status === 200) {
      yield put(getSkillSuperCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillSuperCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillSuperCategoryListApiFailed({ message: error.message }))
  }
}

function* getSkillSuperCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.skillProgram.getSkillSuperCategoryDetails,
      payload,
    )
    if (response.status === 200) {
      yield put(getSkillSuperCategoryDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillSuperCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillSuperCategoryDetailsApiFailed({ message: error.message }))
  }
}

function* addSkillSuperCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.addSkillSuperCategory, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(addSkillSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addSkillSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSkillSuperCategoryApiFailed({ message: error.message }))
  }
}

function* updateSkillSuperCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.updateSkillSuperCategory, payload)
    if (response.status === 200) {
      yield put(updateSkillSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateSkillSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSkillSuperCategoryApiFailed({ message: error.message }))
  }
}

function* deleteSkillSuperCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.deleteSkillSuperCategory, payload)
    if (response.status === 200 || response.status === 204) {
      yield put(deleteSkillSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteSkillSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSkillSuperCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveSkillSuperCategoryApi({ payload }) {
  try {
    const response = yield call(
      API.storeManagement.skillProgram.activeInactiveSkillSuperCategory,
      payload,
    )
    if (response.status === 200) {
      yield put(activeInactiveSkillSuperCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveSkillSuperCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveSkillSuperCategoryApiFailed({ message: error.message }))
  }
}

// -------- Category --------
function* getSkillCategoryListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getCategory, payload)
    if (response.status === 200) {
      yield put(getSkillCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillCategoryListApiFailed({ message: error.message }))
  }
}

function* addSkillCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.addCategory, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(addSkillCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addSkillCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSkillCategoryApiFailed({ message: error.message }))
  }
}

function* updateSkillCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.updateCategory, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(updateSkillCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateSkillCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSkillCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveSkillCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.toggleCategoryStatus, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(activeInactiveSkillCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveSkillCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveSkillCategoryApiFailed({ message: error.message }))
  }
}

function* deleteSkillCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.deleteCategory, payload)
    if (response.status === 200 || response.status === 204) {
      yield put(deleteSkillCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteSkillCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSkillCategoryApiFailed({ message: error.message }))
  }
}

// -------- Sub Category --------
function* getSkillSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getSubCategory, payload)
    if (response.status === 200) {
      yield put(getSkillSubCategoryListApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillSubCategoryListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillSubCategoryListApiFailed({ message: error.message }))
  }
}

function* addSkillSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.addSubCategory, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(addSkillSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(addSkillSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSkillSubCategoryApiFailed({ message: error.message }))
  }
}

function* updateSkillSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.updateSubCategory, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(updateSkillSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(updateSkillSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSkillSubCategoryApiFailed({ message: error.message }))
  }
}

function* activeInactiveSkillSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.toggleSubCategoryStatus, payload)
    if (response.status === 200 || response.status === 201) {
      yield put(activeInactiveSkillSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(activeInactiveSkillSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(activeInactiveSkillSubCategoryApiFailed({ message: error.message }))
  }
}

function* deleteSkillSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.deleteSubCategory, payload)
    if (response.status === 200 || response.status === 204) {
      yield put(deleteSkillSubCategoryApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteSkillSubCategoryApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSkillSubCategoryApiFailed({ message: error.message }))
  }
}

// -------- Skill Program List --------
function* getSkillProgramListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getSkillProgramList, payload)

    if (response.status === 200) {
      yield put(getSkillProgramListApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillProgramListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillProgramListApiFailed({ message: error.message }))
  }
}

// -------- Skill Program Details --------
function* getSkillProgramDetailsApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getSkillProgramDetails, payload)

    if (response.status === 200) {
      yield put(getSkillProgramDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getSkillProgramDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSkillProgramDetailsApiFailed({ message: error.message }))
  }
}

function* deleteSkillProgramApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.deleteSkillProgram, payload)
    if (response.status === 200 || response.status === 204) {
      yield put(deleteSkillProgramApiSuccess({ payload: response.data }))
    } else {
      yield put(deleteSkillProgramApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSkillProgramApiFailed({ message: error.message }))
  }
}

// ================= Applied Skill =================

function* getAppliedSkillListApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getAppliedSkillList, payload)

    if (response.data && response.status === 200) {
      yield put(getAppliedSkillListApiSuccess({ payload: response.data }))
    } else {
      yield put(getAppliedSkillListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAppliedSkillListApiFailed({ message: error.message }))
  }
}

function* getAppliedSkillDetailsApi({ payload }) {
  try {
    const response = yield call(API.storeManagement.skillProgram.getAppliedSkillDetails, payload)

    if (response.data && response.status === 200) {
      yield put(getAppliedSkillDetailsApiSuccess({ payload: response.data }))
    } else {
      yield put(getAppliedSkillDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAppliedSkillDetailsApiFailed({ message: error.message }))
  }
}

function* manageStoreSaga() {
  yield takeEvery(storeRolesListApiData, storeRolesListApi)
  yield takeEvery(addStoreRolesApiData, addStoreRolesApi)
  yield takeEvery(updateStoreRolesApiData, updateStoreRolesApi)
  yield takeEvery(activeInactiveStoreRolesListApiData, activeInactiveStoreRolesListApi)
  yield takeEvery(getStoreTypeListApiData, getStoreListTypeApi)
  yield takeEvery(addStoreTypeListApiData, addStoreTypeListApi)
  yield takeEvery(updateStoreTypeListApiData, updateStoreTypeListApi)
  yield takeEvery(deleteStoreTypeListApiData, deleteStoreTypeListApi)
  yield takeEvery(activeInactiveStoreTypeListApiData, activeInactiveStoreTypeListApi)
  yield takeEvery(getStoreTypeDetailsListApiData, getStoreTypeDetailsListApi)
  yield takeEvery(storeCategoryListApiData, storeCategoryListApi)
  yield takeEvery(storeCategoryDetailsApiData, storeCategoryDetailsApi)
  yield takeEvery(addStoreCategoryApiData, addStoreCategoryApi)
  yield takeEvery(updateStoreCategoryListApiData, updateStoreCategoryListApi)
  yield takeEvery(deleteStoreProductCategoryDataApiData, deleteStoreProductCategoryDataApi)
  yield takeEvery(storeSubCategoryListApiData, storeSubCategoryListApi)
  yield takeEvery(storeSubCategoryDetailsApiData, storeSubCategoryDetailsApi)
  yield takeEvery(addSubStoreCategoryApiData, addSubStoreCategoryApi)
  yield takeEvery(updateStoreSubCategoryListApiData, updateStoreSubCategoryListApi)
  yield takeEvery(deleteStoreSubProductCategoryApiData, deleteStoreSubProductCategoryApi)

  //
  yield takeEvery(storeProductSubChildCategoriesListApiData, storeProductSubChildCategoriesListApi)
  yield takeEvery(
    storeProductSubChildCategoriesItemDetailsApiData,
    storeProductSubChildCategoriesItemDetailsApi,
  )
  yield takeEvery(addStoreProductChildSubCategoryApiData, addStoreProductChildSubCategoryApi)
  yield takeEvery(updateStoreChildSubCategoryListApiData, updateStoreChildSubCategoryListApi)
  yield takeEvery(deleteStoreProductChildSubCategoryApiData, deleteStoreProductChildSubCategoryApi)
  // Brand
  yield takeEvery(brandListApiData, brandListApi)
  yield takeEvery(brandNameDetailsApiData, brandNameDetailsApi)
  yield takeEvery(addBrandApiData, addBrandApi)
  yield takeEvery(updateBrandApiData, updateBrandApi)
  yield takeEvery(deleteBrandApiData, deleteBrandApi)

  // Store Group
  yield takeEvery(getStoreGroupListApiData, getStoreGroupListApi)
  yield takeEvery(addStoreGroupListApiData, addStoreGroupListApi)
  yield takeEvery(updateStoreGroupListApiData, updateStoreGroupListApi)
  yield takeEvery(activeInactiveStoreGroupListApiData, activeInactiveStoreGroupListApi)
  yield takeEvery(deleteStoreGroupListApiData, deleteStoreGroupListApi)
  yield takeEvery(getStoreGroupDetailsListApiData, getStoreGroupDetailsListApi)

  // Store Tag
  yield takeEvery(getStoreTagListApiData, getStoreTagListApi)
  yield takeEvery(addStoreTagApiData, addStoreTagApi)
  yield takeEvery(updateStoreTagApiData, updateStoreTagApi)
  yield takeEvery(deleteStoreTagApiData, deleteStoreTagApi)
  yield takeEvery(activeInactiveStoreTagListApiData, activeInactiveStoreTagListApi)

  // Store Enquiry
  yield takeEvery(getEnquiryListApiData, getEnquiryListApi)
  yield takeEvery(getEnquiryDetailsListApiData, getEnquiryDetailsListApi)

  // Video Category
  yield takeEvery(getStoreVideoCategoryListApiData, getStoreVideoCategoryListApi)
  yield takeEvery(addStoreVideoCategoryApiData, addStoreVideoCategoryApi)
  yield takeEvery(updateStoreVideoCategoryApiData, updateStoreVideoCategoryApi)
  yield takeEvery(activeInactiveStoreVideoCategoryApiData, activeInactiveStoreVideoCategoryApi)
  // store Video
  yield takeEvery(getStoreVideoListApiData, getStoreVideoListApi)
  yield takeEvery(getVideoDetailsData, getVideoDetails)
  yield takeEvery(addStoreVideoApiData, addStoreVideoApi)
  yield takeEvery(updateStoreVideoApiData, updateStoreVideoApi)
  yield takeEvery(activeInactiveStoreVideoApiData, activeInactiveStoreVideoApi)

  // ================= Offer Category =================
  yield takeEvery(getStoreOfferCategoryListApiData, getStoreOfferCategoryListApi)

  yield takeEvery(getStoreOfferCategoryDetailsApiData, getStoreOfferCategoryDetailsApi)

  yield takeEvery(addStoreOfferCategoryApiData, addStoreOfferCategoryApi)

  yield takeEvery(updateStoreOfferCategoryApiData, updateStoreOfferCategoryApi)

  yield takeEvery(activeInactiveStoreOfferCategoryApiData, activeInactiveStoreOfferCategoryApi)
  yield takeEvery(getStoreOfferListApiData, getStoreOfferListApi)
  yield takeEvery(getStoreOfferDetailsApiData, getStoreOfferDetailsApi)
  yield takeEvery(updateOfferApiData, updateOfferApi)

  yield takeEvery(getOfferSubCategoryListApiData, getOfferSubCategoryListApi)
  yield takeEvery(addOfferSubCategoryApiData, addOfferSubCategoryApi)
  yield takeEvery(updateOfferSubCategoryApiData, updateOfferSubCategoryApi)
  yield takeEvery(activeInactiveOfferSubCategoryApiData, activeInactiveOfferSubCategoryApi)
  yield takeEvery(getOfferSubCategoryDetailsApiData, getOfferSubCategoryDetailsApi)

  // ================= Internship =================

  // Internship Super Category
  yield takeEvery(getInternshipSuperCategoryListApiData, getInternshipSuperCategoryListApi)
  yield takeEvery(getInternshipSuperCategoryDetailsApiData, getInternshipSuperCategoryDetailsApi)
  yield takeEvery(addInternshipSuperCategoryApiData, addInternshipSuperCategoryApi)
  yield takeEvery(updateInternshipSuperCategoryApiData, updateInternshipSuperCategoryApi)
  yield takeEvery(deleteInternshipSuperCategoryApiData, deleteInternshipSuperCategoryApi)
  yield takeEvery(
    activeInactiveInternshipSuperCategoryApiData,
    activeInactiveInternshipSuperCategoryApi,
  )

  yield takeEvery(getInternshipCategoryListApiData, getInternshipCategoryListApi)
  yield takeEvery(addInternshipCategoryApiData, addInternshipCategoryApi)
  yield takeEvery(updateInternshipCategoryApiData, updateInternshipCategoryApi)
  yield takeEvery(activeInactiveInternshipCategoryApiData, activeInactiveInternshipCategoryApi)

  yield takeEvery(getInternshipSubCategoryListApiData, getInternshipSubCategoryListApi)
  yield takeEvery(addInternshipSubCategoryApiData, addInternshipSubCategoryApi)
  yield takeEvery(updateInternshipSubCategoryApiData, updateInternshipSubCategoryApi)
  yield takeEvery(
    activeInactiveInternshipSubCategoryApiData,
    activeInactiveInternshipSubCategoryApi,
  )

  yield takeEvery(getInternshipProgramListApiData, getInternshipProgramListApi)
  yield takeEvery(getInternshipProgramDetailsApiData, getInternshipProgramDetailsApi)

  yield takeEvery(getAppliedInternshipListApiData, getAppliedInternshipListApi)

  // ================= Skill Program =================
  yield takeEvery(getSkillProgramTypesListApiData, getSkillProgramTypesListApi)
  yield takeEvery(addSkillProgramTypesApiData, addSkillProgramTypesApi)
  yield takeEvery(updateSkillProgramTypesApiData, updateSkillProgramTypesApi)

  // Skill Super Category
  yield takeEvery(getSkillSuperCategoryListApiData, getSkillSuperCategoryListApi)
  yield takeEvery(getSkillSuperCategoryDetailsApiData, getSkillSuperCategoryDetailsApi)
  yield takeEvery(addSkillSuperCategoryApiData, addSkillSuperCategoryApi)
  yield takeEvery(updateSkillSuperCategoryApiData, updateSkillSuperCategoryApi)
  yield takeEvery(deleteSkillSuperCategoryApiData, deleteSkillSuperCategoryApi)
  yield takeEvery(activeInactiveSkillSuperCategoryApiData, activeInactiveSkillSuperCategoryApi)

  yield takeEvery(activeInactiveSkillProgramTypesApiData, activeInactiveSkillProgramTypesApi)

  yield takeEvery(getSkillCategoryListApiData, getSkillCategoryListApi)
  yield takeEvery(addSkillCategoryApiData, addSkillCategoryApi)
  yield takeEvery(updateSkillCategoryApiData, updateSkillCategoryApi)

  yield takeEvery(activeInactiveSkillCategoryApiData, activeInactiveSkillCategoryApi)

  yield takeEvery(getSkillSubCategoryListApiData, getSkillSubCategoryListApi)
  yield takeEvery(addSkillSubCategoryApiData, addSkillSubCategoryApi)
  yield takeEvery(updateSkillSubCategoryApiData, updateSkillSubCategoryApi)

  yield takeEvery(activeInactiveSkillSubCategoryApiData, activeInactiveSkillSubCategoryApi)

  yield takeEvery(getSkillProgramListApiData, getSkillProgramListApi)
  yield takeEvery(getSkillProgramDetailsApiData, getSkillProgramDetailsApi)

  yield takeEvery(getAppliedSkillListApiData, getAppliedSkillListApi)
  yield takeEvery(getAppliedSkillDetailsApiData, getAppliedSkillDetailsApi)

  // Internship
  yield takeEvery(deleteInternshipCategoryApiData, deleteInternshipCategoryApi)
  yield takeEvery(deleteInternshipSubCategoryApiData, deleteInternshipSubCategoryApi)
  yield takeEvery(deleteInternshipProgramApiData, deleteInternshipProgramApi)

  // Skill
  yield takeEvery(deleteSkillProgramTypesApiData, deleteSkillProgramTypesApi)
  yield takeEvery(deleteSkillCategoryApiData, deleteSkillCategoryApi)
  yield takeEvery(deleteSkillSubCategoryApiData, deleteSkillSubCategoryApi)
  yield takeEvery(deleteSkillProgramApiData, deleteSkillProgramApi)
}

export default manageStoreSaga
